import React from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import Deposit from "../transactions/Deposit"
import ModulesLotteryDraw from "./promotion_modules/modules_lotterDraw"
import ModulePeraBayong from "./promotion_modules/modules_peraBayong"
import ModuleFaChaiGrandSpinAle from "./promotion_modules/modules_fcGrandSpinAle"
import { usePromotionsPage } from "../data/usePromotionsPage"
import AppPromo from "../AppPromo"
import ModuleJiliGrandSlot from "./promotion_modules/ModuleJiliGrandSlot"

const modalComponents = {
  "2/30 Lottery Draw": ModulesLotteryDraw,
  "Pera O Bayong": ModulePeraBayong,
  "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
  "Jili Grand Slot": ModuleJiliGrandSlot,
}

export default function Promotions() {
	const {
		isDepositOpen,
		setIsDepositOpen,

		ActiveModal,
		setActiveModal,
	} = usePromotionsPage({ modalComponents });

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Promotion - FGH - Your One-Stop Gaming Site</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>

			<AppPromo />

			{isDepositOpen &&
				createPortal(
					<div className="modal-portal">
						<Deposit
							onClose={() => setIsDepositOpen(false)}
							defaultBonusName="New Member Package Bonus"
						/>
					</div>,
					document.body,
				)}

			{ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
		</>
	);
}
